import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalProviders"] */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/provider/global-provider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/apps/web/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src999447862/src/ihs-web-app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Open_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-open-sans\"}],\"variableName\":\"openSans\"}");
